import { DEFAULT_CURRENCY_CODE, LOCALE_ID, NgModule } from '@angular/core'
import localeEsMx from '@angular/common/locales/es-MX'
import { registerLocaleData } from '@angular/common'

//* El panel pintaba dólares por no declarar región: sin LOCALE_ID Angular usa `en-US` y el pipe
//* `currency` sin argumento imprime USD. Todo el dinero de la plataforma es MXN (F9).
registerLocaleData(localeEsMx)
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { BrowserModule } from '@angular/platform-browser'
import { SelectButtonModule } from 'primeng/selectbutton'
import { FileUploadModule } from 'primeng/fileupload'
import { PaginatorModule } from 'primeng/paginator'
import { CarouselModule } from 'primeng/carousel'
import { SkeletonModule } from 'primeng/skeleton'
import { DividerModule } from 'primeng/divider'
import { ButtonModule } from 'primeng/button'
import { DialogModule } from 'primeng/dialog'
import { MessageService } from 'primeng/api'
import { ChartModule } from 'primeng/chart'
import { ToastModule } from 'primeng/toast'
import { StepsModule } from 'primeng/steps'
import { TagModule } from 'primeng/tag'

import { CircleCreditControlFiguresCardComponent } from './modules/private/lease/components/lease-circle-credit/modals/circle-credit-cards/circle-credit-control-figures-card.component'
import { CircleCreditAccountDetailCardComponent } from './modules/private/lease/components/lease-circle-credit/modals/circle-credit-cards/circle-credit-account-detail-card.component'
import { CircleCreditPersonalDataCardComponent } from './modules/private/lease/components/lease-circle-credit/modals/circle-credit-cards/circle-credit-personal-data-card.component'
import { CircleCreditShareholderCardComponent } from './modules/private/lease/components/lease-circle-credit/modals/circle-credit-cards/circle-credit-shareholder-card.component'
import { CircleCreditEmploymentCardComponent } from './modules/private/lease/components/lease-circle-credit/modals/circle-credit-cards/circle-credit-employment-card.component'
import { CircleCreditGuarantorCardComponent } from './modules/private/lease/components/lease-circle-credit/modals/circle-credit-cards/circle-credit-guarantor-card.component'
import { CircleCreditEditModalComponent } from './modules/private/lease/components/lease-circle-credit/modals/circle-credit-edit-modal/circle-credit-edit-modal.component'
import { CircleCreditAddressCardComponent } from './modules/private/lease/components/lease-circle-credit/modals/circle-credit-cards/circle-credit-address-card.component'
import { CircleCreditCompanyCardComponent } from './modules/private/lease/components/lease-circle-credit/modals/circle-credit-cards/circle-credit-company-card.component'
import { CircleCreditCreditsCardComponent } from './modules/private/lease/components/lease-circle-credit/modals/circle-credit-cards/circle-credit-credits-card.component'
// Circle Credit Card Components
import { CircleCreditHeaderCardComponent } from './modules/private/lease/components/lease-circle-credit/modals/circle-credit-cards/circle-credit-header-card.component'
import { EditStartDateModalComponent } from '@modules/private/lease/components/lease-enforceability/modals/edit-start-date-modal/edit-start-date-modal.component'
import { LeaseDistributionSelectorComponent } from '@modules/private/payment/components/lease-distribution-selector/lease-distribution-selector.component'
import { EditAmountsModalComponent } from '@modules/private/lease/components/lease-enforceability/modals/edit-amounts-modal/edit-amounts-modal.component'
import { ApplyPreviewDialogComponent } from '@modules/private/lease/components/lease-enforceability/apply-preview-dialog/apply-preview-dialog.component'
import { InvoiceComplementsDialogComponent } from '@modules/private/invoices/components/invoice-complements-dialog/invoice-complements-dialog.component'
import { Step6AplicacionComponent } from '@modules/private/payment/components/payment-batch-wizard/steps/step6-aplicacion/step6-aplicacion.component'
import { GuarantorContactDialogComponent } from '@modules/private/customer/components/guarantor-contact-dialog/guarantor-contact-dialog.component'
import { RoadmapProjectShowcaseComponent } from '@modules/private/roadmap/components/roadmap-project-showcase/roadmap-project-showcase.component'
import { QuoteParametersPreviewComponent } from '@modules/private/quote/components/quote-parameters-preview/quote-parameters-preview.component'
import { Step2RevisionComponent } from '@modules/private/payment/components/payment-batch-wizard/steps/step2-revision/step2-revision.component'
import { Step3RegistroComponent } from '@modules/private/payment/components/payment-batch-wizard/steps/step3-registro/step3-registro.component'
import { Step4DestinosComponent } from '@modules/private/payment/components/payment-batch-wizard/steps/step4-destinos/step4-destinos.component'
import { CustomerDocumentsTabsComponent } from '@modules/private/customer/components/customer-documents-tabs/customer-documents-tabs.component'
import { CustomerCreditHistoryComponent } from '@modules/private/customer/components/customer-credit-history/customer-credit-history.component'
import { CustomerBankAccountsComponent } from '@modules/private/customer/components/customer-bank-accounts/customer-bank-accounts.component'
import { LeaseAssetAcquisitionComponent } from '@modules/private/lease/components/lease-asset-acquisition/lease-asset-acquisition.component'
import { Step1ArchivoComponent } from '@modules/private/payment/components/payment-batch-wizard/steps/step1-archivo/step1-archivo.component'
import { Step5ImpactoComponent } from '@modules/private/payment/components/payment-batch-wizard/steps/step5-impacto/step5-impacto.component'
import { InvoicesUploadDialogComponent } from '@modules/private/invoices/components/invoices-upload-dialog/invoices-upload-dialog.component'
import { Step2ChannelsComponent } from './modules/private/dripping/components/strategy-wizard/steps/step2-channels/step2-channels.component'
import { WrittenOffChipComponent } from '@modules/private/lease/components/lease-enforceability/written-off-chip/written-off-chip.component'
import { RoadmapProjectDetailComponent } from '@modules/private/roadmap/components/roadmap-project-detail/roadmap-project-detail.component'
import { CustomerBillingFormComponent } from './modules/private/customer/components/customer-billing-form/customer-billing-form.component'
import { SmsCharacterCounterComponent } from './modules/private/dripping/components/sms-character-counter/sms-character-counter.component'
// Omnichannel (Cotización 2026 #1)
import { OmnichannelTimelineComponent } from '@modules/private/omnichannel/components/omnichannel-timeline/omnichannel-timeline.component'
import { AssignChannelModalComponent } from '@modules/private/omnichannel/components/assign-channel-modal/assign-channel-modal.component'
import { PaymentAttentionTabComponent } from '@modules/private/payment/components/payment-attention-tab/payment-attention-tab.component'
import { WorklogCreateDialogComponent } from '@modules/private/worklog/components/worklog-create-dialog/worklog-create-dialog.component'
import { PaymentDrawerComponent } from '@modules/private/lease/components/lease-enforceability/payment-drawer/payment-drawer.component'
import { DocumentationProgressComponent } from '@modules/private/documentation/documentation-progress/documentation-progress.component'
import { PreofferReviewDetailComponent } from '@modules/private/preoffer/views/preoffer-review-detail/preoffer-review-detail.component'
import { ReassignOwnerModalComponent } from '@modules/private/customer/components/reassign-owner-modal/reassign-owner-modal.component'
import { TimelineEventItemComponent } from '@modules/private/omnichannel/components/timeline-event-item/timeline-event-item.component'
import { ChannelSourceFormComponent } from '@modules/private/omnichannel/components/channel-source-form/channel-source-form.component'
import { PaymentAdjustModalComponent } from '@modules/private/payment/components/payment-adjust-modal/payment-adjust-modal.component'
import { PaymentBatchWizardComponent } from '@modules/private/payment/components/payment-batch-wizard/payment-batch-wizard.component'
import { CreditValidationDetailComponent } from '@modules/private/credit-history/views/validation-detail/validation-detail.component'
import { BillingDisplayComponent } from './modules/private/lease/components/lease-billing/billing-display/billing-display.component'
import { LeaseEnforceabilityComponent } from '@modules/private/lease/components/lease-enforceability/lease-enforceability.component'
import { PeriodDetailComponent } from '@modules/private/lease/components/lease-enforceability/period-detail/period-detail.component'
import { PaymentsViewComponent } from '@modules/private/lease/components/lease-enforceability/payments-view/payments-view.component'
import { LeaseSituationPillComponent } from './modules/private/lease/components/lease-situation-pill/lease-situation-pill.component'
import { PreofferReviewsListComponent } from '@modules/private/preoffer/views/preoffer-reviews-list/preoffer-reviews-list.component'
import { CiecRequestDialogComponent } from '@modules/private/customer/components/ciec-request-dialog/ciec-request-dialog.component'
import { AssignWalletDialogComponent } from '@modules/private/lease/components/assign-wallet-dialog/assign-wallet-dialog.component'
import { LeaseBillingResumeComponent } from '@modules/private/lease/components/lease-billing-resume/lease-billing-resume.component'
import { LeaseLedgerDialogComponent } from '@modules/private/cobranza/components/lease-ledger-dialog/lease-ledger-dialog.component'
import { Step1BasicComponent } from './modules/private/dripping/components/strategy-wizard/steps/step1-basic/step1-basic.component'
import { CloseClientModalComponent } from '@modules/private/omnichannel/components/close-client-modal/close-client-modal.component'
import { FunnelTaskDetailComponent } from '@modules/private/omnichannel/components/funnel-task-detail/funnel-task-detail.component'
import { CampaignDashboardComponent } from './modules/private/dripping/components/campaign-dashboard/campaign-dashboard.component'
import { WorklogItemDetailComponent } from '@modules/private/worklog/components/worklog-item-detail/worklog-item-detail.component'
import { WorklogEpicDetailComponent } from '@modules/private/worklog/components/worklog-epic-detail/worklog-epic-detail.component'
import { PaymentDateDialogComponent } from '@modules/private/payment/components/payment-date-dialog/payment-date-dialog.component'
import { CreditValidationsListComponent } from '@modules/private/credit-history/views/validations-list/validations-list.component'
import { ReportesContablesComponent } from '@modules/private/cobranza/components/reportes-contables/reportes-contables.component'
import { CustomerDocumentsComponent } from '@modules/private/customer/components/customer-documents/customer-documents.component'
import { LedgerStripComponent } from '@modules/private/lease/components/lease-enforceability/ledger-strip/ledger-strip.component'
import { LeaseCircleCreditComponent } from './modules/private/lease/components/lease-circle-credit/lease-circle-credit.component'
// Documentación interna (manuales comentables)
import { DocumentationViewerComponent } from '@modules/private/documentation/documentation-viewer/documentation-viewer.component'
import { NotificationBellComponent } from '@modules/private/omnichannel/components/notification-bell/notification-bell.component'
import { NewSessionDialogComponent } from '@modules/private/committee/components/new-session-dialog/new-session-dialog.component'
import { AssignAssetDialogComponent } from '@modules/private/lease/components/assign-asset-dialog/assign-asset-dialog.component'
import { LeaseStartPaymentComponent } from '@modules/private/lease/components/lease-start-payment/lease-start-payment.component'
import { EditFolioModalComponent } from '@modules/private/lease/lease-detail/modals/edit-folio-modal/edit-folio-modal.component'
import { LeaseStatusChangeComponent } from '@modules/private/lease/components/lease-status-change/lease-status-change.component'
import { CampaignProgressComponent } from './modules/private/dripping/components/campaign-progress/campaign-progress.component'
import { TrackingTimelineComponent } from './modules/private/dripping/components/tracking-timeline/tracking-timeline.component'
import { WorklogSprintBarComponent } from '@modules/private/worklog/components/worklog-sprint-bar/worklog-sprint-bar.component'
import { WorklogAreaSplitComponent } from '@modules/private/worklog/components/worklog-area-split/worklog-area-split.component'
import { JointHolderFlowsComponent } from './modules/private/lease/components/joint-holder-flows/joint-holder-flows.component'
import { TemplatePreviewComponent } from './modules/private/dripping/components/template-preview/template-preview.component'
import { CampaignMetricsComponent } from './modules/private/dripping/components/campaign-metrics/campaign-metrics.component'
import { OmnichannelMetricsComponent } from '@modules/private/omnichannel/omnichannel-metrics/omnichannel-metrics.component'
import { RoadmapEpicCardComponent } from '@modules/private/roadmap/components/roadmap-epic-card/roadmap-epic-card.component'
import { WorklogRichTextComponent } from '@modules/private/worklog/components/worklog-rich-text/worklog-rich-text.component'
import { LeaseNegotiationComponent } from '@modules/private/lease/components/lease-negotiation/lease-negotiation.component'
import { BillingFormComponent } from './modules/private/lease/components/lease-billing/billing-form/billing-form.component'
import { LeaseFormCreateComponent } from './modules/private/lease/components/lease-form-create/lease-form-create.component'
import { InvoiceRulesListComponent } from './modules/private/invoice-rules/invoice-rules-list/invoice-rules-list.component'
import { BankFlowsHolderComponent } from './modules/private/lease/components/bank-flows-holder/bank-flows-holder.component'
import { RiskExcelUploadComponent } from './modules/private/lease/components/risk-excel-upload/risk-excel-upload.component'
import { CommunicationsListComponent } from './modules/private/dripping/communications-list/communications-list.component'
import { RoadmapProjectsComponent } from '@modules/private/roadmap/components/roadmap-projects/roadmap-projects.component'
import { WorklogTimelineComponent } from '@modules/private/worklog/components/worklog-timeline/worklog-timeline.component'
import { PreofferSettingsComponent } from '@modules/private/preoffer/views/preoffer-settings/preoffer-settings.component'
import { FinancialRatiosComponent } from './modules/private/lease/components/financial-ratios/financial-ratios.component'
import { LeaseCalculatorComponent } from './modules/private/lease/components/lease-calculator/lease-calculator.component'
import { VariablePickerComponent } from './modules/private/dripping/components/variable-picker/variable-picker.component'
import { StrategyWizardComponent } from './modules/private/dripping/components/strategy-wizard/strategy-wizard.component'
import { CampaignDetailComponent } from './modules/private/dripping/components/campaign-detail/campaign-detail.component'
import { AvanceCapturasComponent } from '@modules/private/cobranza/components/avance-capturas/avance-capturas.component'
import { LeaseSettlementComponent } from '@modules/private/lease/components/lease-settlement/lease-settlement.component'
import { CobranzaFunnelComponent } from '@modules/private/cobranza/components/cobranza-funnel/cobranza-funnel.component'
import { ProviderDetailComponent } from '@modules/private/provider/components/provider-detail/provider-detail.component'
import { PendingBalancesComponent } from './modules/private/home/components/pending-balances/pending-balances.component'
import { MonthlyBalancesComponent } from './modules/private/home/components/monthly-balances/monthly-balances.component'
import { AssetTypeFieldComponent } from '@modules/private/quote/components/asset-type-field/asset-type-field.component'
import { WorklogBacklogComponent } from '@modules/private/worklog/components/worklog-backlog/worklog-backlog.component'
import { WorklogHistoryComponent } from '@modules/private/worklog/components/worklog-history/worklog-history.component'
import { CommitteeLeasesComponent } from '@modules/private/committee/views/committee-leases/committee-leases.component'
// Step3AdvancedComponent ELIMINADO - wizard reducido a 2 pasos
// ChannelTimelineComponent ELIMINADO - ya no se usa timeline de prioridades
import { LeaseSelectorComponent } from './modules/private/dripping/components/lease-selector/lease-selector.component'
import { OmnichannelAdminComponent } from '@modules/private/omnichannel/omnichannel-admin/omnichannel-admin.component'
import { LeaseDocumentsComponent } from '@modules/private/lease/components/lease-documents/lease-documents.component'
import { LeaseAlgorithmComponent } from '@modules/private/lease/components/lease-algorithm/lease-algorithm.component'
import { LeaseCommitteeComponent } from '@modules/private/lease/components/lease-committee/lease-committee.component'
import { LeaseAgreementComponent } from '@modules/private/lease/components/lease-agreement/lease-agreement.component'
import { InvoicesTableComponent } from '@modules/private/invoices/components/invoices-table/invoices-table.component'
import { ClientsOverdueComponent } from './modules/private/home/components/clients-overdue/clients-overdue.component'
import { ChannelBadgeComponent } from '@modules/private/omnichannel/components/channel-badge/channel-badge.component'
import { MetricChartComponent } from '@modules/private/roadmap/components/charts/metric-chart/metric-chart.component'
import { PaymentsTableComponent } from '@modules/private/payment/components/payments-table/payments-table.component'
import { AdminRoleFormComponent } from '@modules/private/admin/components/admin-role-form/admin-role-form.component'
import { WalletsDetailComponent } from './modules/private/wallet/components/wallets-detail/wallets-detail.component'
import { WorklogEditorComponent } from '@modules/private/worklog/components/worklog-editor/worklog-editor.component'
import { ProviderFormComponent } from './modules/private/provider/components/provider-form/provider-form.component'
import { TemplateFormComponent } from './modules/private/dripping/components/template-form/template-form.component'
import { EmailPreviewComponent } from './modules/private/dripping/components/email-preview/email-preview.component'
import { LeaseCustomerComponent } from '@modules/private/lease/components/lease-customer/lease-customer.component'
import { LeaseAnalysisComponent } from '@modules/private/lease/components/lease-analysis/lease-analysis.component'
import { LeaseActivityComponent } from '@modules/private/lease/components/lease-activity/lease-activity.component'
import { MonthlyTargetComponent } from './modules/private/home/components/monthly-target/monthly-target.component'
import { ApiQuoteParametersService } from './modules/private/quote/data/services/api/api-quote-parameters.service'
// Worklog (Mapa de trabajo: Backlog + Tablero, DB · Admin-only vía roadmap.view)
import { WorklogContainerComponent } from '@modules/private/worklog/worklog-container/worklog-container.component'
import { AdminDetailsComponent } from './modules/private/wallet/components/admin-details/admin-details.component'
import { RoadmapEpicsComponent } from '@modules/private/roadmap/components/roadmap-epics/roadmap-epics.component'
import { RoadmapBoardComponent } from '@modules/private/roadmap/components/roadmap-board/roadmap-board.component'
import { WorklogGanttComponent } from '@modules/private/worklog/components/worklog-gantt/worklog-gantt.component'
import { WorklogBoardComponent } from '@modules/private/worklog/components/worklog-board/worklog-board.component'
import { WorklogTraceComponent } from '@modules/private/worklog/components/worklog-trace/worklog-trace.component'
import { SessionDetailComponent } from '@modules/private/committee/views/session-detail/session-detail.component'
import { EmailDetailComponent } from './modules/private/dripping/components/email-detail/email-detail.component'
import { RiskScorecardConfigModule } from './modules/private/risk-scorecard-config/risk-scorecard-config.module'
import { CustomerNewComponent } from '@modules/private/customer/components/customer-new/customer-new.component'
import { LeaseReleaseComponent } from '@modules/private/lease/components/lease-release/lease-release.component'
import { LeaseBillingComponent } from '@modules/private/lease/components/lease-billing/lease-billing.component'
import { PaymentFormComponent } from '@modules/private/payment/components/payment-form/payment-form.component'
import { TemplateDetailComponent } from './modules/private/dripping/template-detail/template-detail.component'
import { StrategiesListComponent } from './modules/private/dripping/strategies-list/strategies-list.component'
import { StrategyDetailComponent } from './modules/private/dripping/strategy-detail/strategy-detail.component'
import { CommitteesPageComponent } from '@modules/private/committee/committees-page/committees-page.component'
import { SessionsListComponent } from '@modules/private/committee/views/sessions-list/sessions-list.component'
import { CustomerDetailComponent } from '@modules/private/customer/customer-detail/customer-detail.component'
import { QuoteDetailComponent } from './modules/private/quote/components/quote-detail/quote-detail.component'
import { LeaseActiveComponent } from '@modules/private/lease/components/lease-active/lease-active.component'
import { LeaseQuotesComponent } from '@modules/private/lease/components/lease-quotes/lease-quotes.component'
import { AyudaCifraComponent } from '@modules/private/cobranza/components/ayuda-cifra/ayuda-cifra.component'
import { AdminAdminsComponent } from '@modules/private/admin/components/admin-admins/admin-admins.component'
import { ConciliacionComponent } from '@modules/private/cobranza/views/conciliacion/conciliacion.component'
import { TemplatesListComponent } from './modules/private/dripping/templates-list/templates-list.component'
import { CampaignsListComponent } from './modules/private/dripping/campaigns-list/campaigns-list.component'
import { ActiveFormComponent } from '@modules/private/active/components/active-form/active-form.component'
import { LeaseLegalComponent } from '@modules/private/lease/components/lease-legal/lease-legal.component'
import { AdminRolesComponent } from '@modules/private/admin/components/admin-roles/admin-roles.component'
import { ProviderListComponent } from './modules/private/provider/provider-list/provider-list.component'
import { CustomerListComponent } from '@modules/private/customer/customer-list/customer-list.component'
import { CobranzaPageComponent } from '@modules/private/cobranza/cobranza-page/cobranza-page.component'
import { FunnelTasksComponent } from '@modules/private/omnichannel/funnel-tasks/funnel-tasks.component'
import { QuoteFormComponent } from '@modules/private/quote/components/quote-form/quote-form.component'
import { AdminFormComponent } from '@modules/private/admin/components/admin-form/admin-form.component'
import { HomeDashboardComponent } from '@modules/private/home/home-dashboard/home-dashboard.component'
import { NewLeasesComponent } from './modules/private/home/components/new-leases/new-leases.component'
import { ActiveDetailComponent } from '@modules/private/active/active-detail/active-detail.component'
import { ChangePasswordComponent } from '@modules/public/change-password/change-password.component'
import { PaymentListComponent } from '@modules/private/payment/payment-list/payment-list.component'
// Roadmap (Admin-only)
import { RoadmapPageComponent } from '@modules/private/roadmap/roadmap-page/roadmap-page.component'
import { AlgorithmConfigModule } from './modules/private/algorithm-config/algorithm-config.module'
import { SkeletonLeftnavComponent } from './skeleton/skeleton-leftnav/skeleton-leftnav.component'
import { LeaseDetailComponent } from '@modules/private/lease/lease-detail/lease-detail.component'
import { ActiveListComponent } from '@modules/private/active/active-list/active-list.component'
import { WalletListComponent } from '@modules/private/wallet/wallet-list/wallet-list.component'
import { ReporteriaComponent } from './modules/private/reports/reporteria/reporteria.component'
import { SkeletonHeaderComponent } from './skeleton/skeleton-header/skeleton-header.component'
import { SkeletonFooterComponent } from './skeleton/skeleton-footer/skeleton-footer.component'
import { CentralComponent } from '@modules/private/cobranza/views/central/central.component'
import { CarteraComponent } from '@modules/private/cobranza/views/cartera/cartera.component'
import { RatiosComponent } from './modules/private/lease/components/ratios/ratios.component'
import { QuoteListComponent } from '@modules/private/quote/quote-list/quote-list.component'
import { LeaseListComponent } from '@modules/private/lease/lease-list/lease-list.component'
import { AdminListComponent } from '@modules/private/admin/admin-list/admin-list.component'
import { AssetsComponent } from './modules/private/home/components/assets/assets.component'
import { AvanceComponent } from '@modules/private/cobranza/views/avance/avance.component'
import { WalletConfigModule } from './modules/private/wallet-config/wallet-config.module'
import { InvoicesComponent } from '@modules/private/invoices/invoices.component'
import { BugReportModule } from '@modules/private/bug-report/bug-report.module'
import { LogoutComponent } from '@modules/private/logout/logout.component'
import { QuoterComponent } from './modules/public/quoter/quoter.component'
import { LoginComponent } from '@modules/public/login/login.component'
import { IsoDateEnumPipe } from '@data/pipes/enum/iso-date-enum.pipe'
import { SkeletonComponent } from './skeleton/skeleton.component'
import { AppRoutingModule } from './app-routing.module'
import { SharedModule } from '@shared/shared.module'
import { AppComponent } from './app.component'
import { CoreModule } from '@app/core.module'

@NgModule({
  declarations: [
    AppComponent,
    SkeletonComponent,
    SkeletonHeaderComponent,
    SkeletonLeftnavComponent,
    SkeletonFooterComponent,
    IsoDateEnumPipe,
    HomeDashboardComponent,
    LoginComponent,
    ChangePasswordComponent,
    LogoutComponent,
    ActiveListComponent,
    ActiveFormComponent,
    ActiveDetailComponent,
    CustomerListComponent,
    CustomerNewComponent,
    CustomerDetailComponent,
    ReassignOwnerModalComponent,
    GuarantorContactDialogComponent,
    AssetTypeFieldComponent,
    CustomerDocumentsComponent,
    CustomerDocumentsTabsComponent,
    CustomerCreditHistoryComponent,
    CreditValidationsListComponent,
    PreofferReviewsListComponent,
    PreofferReviewDetailComponent,
    PreofferSettingsComponent,
    CreditValidationDetailComponent,
    CustomerBankAccountsComponent,
    CiecRequestDialogComponent,
    QuoteListComponent,
    QuoteFormComponent,
    QuoteParametersPreviewComponent,
    LeaseListComponent,
    LeaseDetailComponent,
    AssignWalletDialogComponent,
    AssignAssetDialogComponent,
    LeaseCustomerComponent,
    LeaseActiveComponent,
    LeaseQuotesComponent,
    LeaseDocumentsComponent,
    LeaseAnalysisComponent,
    LeaseAlgorithmComponent,
    LeaseCommitteeComponent,
    LeaseNegotiationComponent,
    LeaseLegalComponent,
    LeaseAgreementComponent,
    LeaseStartPaymentComponent,
    LeaseAssetAcquisitionComponent,
    LeaseReleaseComponent,
    LeaseBillingComponent,
    BillingFormComponent,
    BillingDisplayComponent,
    LeaseSettlementComponent,
    WalletListComponent,
    LeaseBillingResumeComponent,
    LeaseEnforceabilityComponent,
    ApplyPreviewDialogComponent,
    LedgerStripComponent,
    WrittenOffChipComponent,
    PeriodDetailComponent,
    PaymentDrawerComponent,
    PaymentsViewComponent,
    EditStartDateModalComponent,
    EditAmountsModalComponent,
    EditFolioModalComponent,
    LeaseActivityComponent,
    LeaseStatusChangeComponent,
    CobranzaPageComponent,
    CobranzaFunnelComponent,
    AyudaCifraComponent,
    CommitteesPageComponent,
    SessionsListComponent,
    CommitteeLeasesComponent,
    SessionDetailComponent,
    NewSessionDialogComponent,
    CentralComponent,
    LeaseLedgerDialogComponent,
    AvanceCapturasComponent,
    ReportesContablesComponent,
    CarteraComponent,
    AvanceComponent,
    ConciliacionComponent,
    PaymentListComponent,
    PaymentsTableComponent,
    PaymentDateDialogComponent,
    InvoicesTableComponent,
    PaymentFormComponent,
    AdminListComponent,
    AdminRolesComponent,
    AdminAdminsComponent,
    AdminRoleFormComponent,
    AdminFormComponent,
    ProviderListComponent,
    ProviderDetailComponent,
    LeaseFormCreateComponent,
    QuoteDetailComponent,
    ProviderFormComponent,
    PaymentAdjustModalComponent,
    LeaseDistributionSelectorComponent,
    PaymentBatchWizardComponent,
    Step1ArchivoComponent,
    Step2RevisionComponent,
    Step3RegistroComponent,
    Step4DestinosComponent,
    Step5ImpactoComponent,
    Step6AplicacionComponent,
    PaymentAttentionTabComponent,
    InvoicesComponent,
    InvoicesUploadDialogComponent,
    InvoiceComplementsDialogComponent,
    WalletsDetailComponent,
    AdminDetailsComponent,
    ReporteriaComponent,
    InvoiceRulesListComponent,
    LeaseSituationPillComponent,
    ClientsOverdueComponent,
    AssetsComponent,
    MonthlyTargetComponent,
    NewLeasesComponent,
    PendingBalancesComponent,
    MonthlyBalancesComponent,
    BankFlowsHolderComponent,
    JointHolderFlowsComponent,
    RatiosComponent,
    FinancialRatiosComponent,
    LeaseCalculatorComponent,
    RiskExcelUploadComponent,
    LeaseCircleCreditComponent,
    CircleCreditEditModalComponent,

    // Circle Credit Card Components
    CircleCreditHeaderCardComponent,
    CircleCreditPersonalDataCardComponent,
    CircleCreditAddressCardComponent,
    CircleCreditEmploymentCardComponent,
    CircleCreditCompanyCardComponent,
    CircleCreditAccountDetailCardComponent,
    CircleCreditControlFiguresCardComponent,
    CircleCreditCreditsCardComponent,
    CircleCreditShareholderCardComponent,
    CircleCreditGuarantorCardComponent,
    QuoterComponent,
    CustomerBillingFormComponent,

    // Dripping Components
    TemplatesListComponent,
    TemplateDetailComponent,
    TemplateFormComponent,
    VariablePickerComponent,
    TemplatePreviewComponent,
    SmsCharacterCounterComponent,
    StrategiesListComponent,
    StrategyDetailComponent,
    StrategyWizardComponent,
    Step1BasicComponent,
    Step2ChannelsComponent,
    // Step3AdvancedComponent ELIMINADO
    // ChannelTimelineComponent ELIMINADO
    LeaseSelectorComponent,
    CampaignsListComponent,
    CampaignDashboardComponent,
    CampaignMetricsComponent,
    CampaignProgressComponent,
    CampaignDetailComponent,

    // Communications Components
    CommunicationsListComponent,
    EmailDetailComponent,
    EmailPreviewComponent,
    TrackingTimelineComponent,

    // Documentación interna (manuales comentables)
    DocumentationViewerComponent,
    DocumentationProgressComponent,

    // Roadmap (Admin-only)
    RoadmapPageComponent,
    RoadmapEpicsComponent,
    RoadmapEpicCardComponent,
    RoadmapProjectsComponent,
    RoadmapProjectDetailComponent,
    RoadmapProjectShowcaseComponent,
    RoadmapBoardComponent,
    WorklogGanttComponent,
    MetricChartComponent,
    // Worklog (Mapa de trabajo: Backlog + Tablero)
    WorklogContainerComponent,
    WorklogBacklogComponent,
    WorklogBoardComponent,
    WorklogAreaSplitComponent,
    WorklogItemDetailComponent,
    WorklogTraceComponent,
    WorklogEditorComponent,
    WorklogRichTextComponent,
    WorklogCreateDialogComponent,
    WorklogHistoryComponent,
    WorklogTimelineComponent,
    WorklogEpicDetailComponent,
    WorklogSprintBarComponent,
    // Omnichannel (Cotización 2026 #1)
    OmnichannelTimelineComponent,
    TimelineEventItemComponent,
    ChannelBadgeComponent,
    AssignChannelModalComponent,
    CloseClientModalComponent,
    ChannelSourceFormComponent,
    FunnelTaskDetailComponent,
    NotificationBellComponent,
    OmnichannelAdminComponent,
    FunnelTasksComponent,
    OmnichannelMetricsComponent,
  ],
  imports: [
    // Reportar un problema desde cualquier pantalla: se monta en el shell, no en una ruta.
    BugReportModule,
    CoreModule,
    BrowserModule,
    AppRoutingModule,
    SharedModule,
    BrowserAnimationsModule,
    CarouselModule,
    SkeletonModule,
    PaginatorModule,
    ChartModule,
    WalletConfigModule,
    AlgorithmConfigModule,
    RiskScorecardConfigModule,
    ToastModule,
    StepsModule,
    SelectButtonModule,
    DividerModule,
    FileUploadModule,
    TagModule,
    ButtonModule,
    DialogModule,
  ],
  providers: [ApiQuoteParametersService, MessageService, { provide: LOCALE_ID, useValue: 'es-MX' }, { provide: DEFAULT_CURRENCY_CODE, useValue: 'MXN' }],
  exports: [],
  bootstrap: [AppComponent],
})
export class AppModule {}
